var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9648 5.14282H19.9558C19.8192 5.14282 19.6906 5.20978 19.6103 5.3196L12.0004 15.8089L4.39062 5.3196C4.31026 5.20978 4.1817 5.14282 4.04508 5.14282H2.03616C1.86205 5.14282 1.76027 5.34104 1.86205 5.483L11.3067 18.5035C11.6496 18.975 12.3513 18.975 12.6915 18.5035L22.1362 5.483C22.2406 5.34104 22.1388 5.14282 21.9648 5.14282Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBottom);
export default __webpack_public_path__ + "static/media/dropdown-bottom.0c3b882b18445ec9e7087556c49c4dfb.svg";
export { ForwardRef as ReactComponent };